import React from 'react';
import { faShareSquare } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
import { MassReassignBookingsDialog } from '../modals/mass-reassign-bookings-dialog/mass-reassign-bookings-dialog';

export const actions: IAction[] = [
  {
    context: 'Bookings',
    id: 'BulkAssignment',
    displayName: 'Massetildeling',
    icon: faShareSquare,
    action: selectedEntries => <MassReassignBookingsDialog bookingIds={selectedEntries} />,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > 250 ? 'Antallet af valgte elementer må ikke overstige 250' : ''),
  },
];
